import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 *
 * @returns the PUID of the current user
 */
export const getUserPuid = (): string => getUserConfiguration().SessionSettings?.UserPuid;
